import { render } from "./From.vue?vue&type=template&id=39fd3224&ts=true"
import script from "./From.vue?vue&type=script&lang=ts"
export * from "./From.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__